import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useRegisterAdminAnnouncementBannerQuery, {
	type useRegisterAdminAnnouncementBannerQuery$data,
	type useRegisterAdminAnnouncementBannerQuery$variables,
} from './__generated__/useRegisterAdminAnnouncementBannerQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export const preloadAdminAnnouncementBanner = (): Promise<{
	data: useRegisterAdminAnnouncementBannerQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> =>
	query<
		useRegisterAdminAnnouncementBannerQuery$data,
		useRegisterAdminAnnouncementBannerQuery$variables
	>({
		query: useRegisterAdminAnnouncementBannerQuery,
	});
